<template>
  <v-navigation-drawer app overflow :value="show">
    <v-list dense class="py-0">
      <!-- Logo -->
      <v-list-item
        two-line
        class="px-12 pt-1 pb-0"
        style="display: sticky; top: 0;"
      >
        <router-link to="/">
          <v-img v-if="!logo" :src="$root.cdn + 'logo.png'" width="160px" height="32px" />
          <v-img v-else :src="logo" width="160px"  height="32px" style="object-fit: cover"/>
        </router-link>
      </v-list-item>

      <!-- Main page -->
      <template v-if="state === MENU_STATE.MainPage">
        <template v-if="$store.getters.canAccessAgentProducts">
          <menu-item
            v-for="(item, i) in permittedAgentItems"
            :menuItem="item"
            exactLink="dashboard"
            :key="item.title + i"
          ></menu-item>
        </template>
        <template v-if="permittedPartnershipAdminItems.length && $store.getters.canAccessPartnershipAdminOptions">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="grey--text text-center">Admin</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />

          <menu-item
            v-for="(item, i) in permittedPartnershipAdminItems"
            :menuItem="item"
            :exactLink="PARTNERSHIP_ADMIN_PATH"
            :key="item.title + i"
          ></menu-item>
        </template>
      </template>

      <!-- Admin page -->
      <template v-else>
        <template v-if="showSystemAdminMenu">
          <v-btn class="ma-5" color="primary" dark to="/">
            <v-icon dark left>mdi-arrow-left</v-icon>
            Back
          </v-btn>

          <menu-item
            v-for="(item, i) in permittedSystemAdminItems"
            :menuItem="item"
            :exactLink="SYSTEM_ADMIN_PATH"
            :key="item.icon + i"
          ></menu-item>
        </template>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import MenuItem from './MenuItem.vue';
import { SYSTEM_ADMIN_ROUTES } from '../router/system-admin.routes';
import { PARTNERSHIP_ADMIN_ROUTES } from '../router/partnership-admin.routes';
import {
  AGENT_ITEMS, 
  PARTNERSHIP_ADMIN_ITEMS,
  SYSTEM_ADMIN_ITEMS,
} from '../global/menu';

const MENU_STATE = {
  MainPage: 'MainPage',
  AdminPage: 'AdminPage',
}

export default {
  name: 'AppMenu',
  props: {
    show: Boolean
  },
  components: { MenuItem },
  data: () => ({
    logo:null,
    url:process.env.VUE_APP_API_BASE_URL,
    MENU_STATE,
    PARTNERSHIP_ADMIN_PATH: PARTNERSHIP_ADMIN_ROUTES.path,
    SYSTEM_ADMIN_PATH: SYSTEM_ADMIN_ROUTES.path,

    state: null,
    agentItems: AGENT_ITEMS,
    partnershipAdminItems: PARTNERSHIP_ADMIN_ITEMS,
    systemAdminItems: SYSTEM_ADMIN_ITEMS,
  }),
  mounted() {
    const isAdminSettings = this.$route.path.includes(this.SYSTEM_ADMIN_PATH);
    const state = isAdminSettings ? MENU_STATE.AdminPage : MENU_STATE.MainPage;
    this.getLogo(this.user);
    this.setState(state);
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    showSystemAdminMenu() {
      return this.$store.getters.canAccessSystemAdminSettings;
    },
    permittedAgentItems() {
      return this.agentItems.filter(this.filterItem);
    },
    permittedPartnershipAdminItems() {
      return this.partnershipAdminItems.filter(this.filterItem);
    },
    permittedSystemAdminItems() {
      return this.systemAdminItems.filter(this.filterItem);
    },
  },
  methods: {
    getLogo(params){

      if(params && params.partnership && params.partnership.small_logo){
        this.logo = this.url+'logos/'+params.partnership.small_logo;
      }
    },
    filterItem({ perm, role }) {
      const { userCan, userIs } = this.$store.getters;

      return (!perm && !role) || (userCan(perm) || userIs(role));
    },
    setState(state) {
      if (state in MENU_STATE) {
        this.state = state;
      } else {
        throw Error('Incorrect state value');
      }
    },
  },
  watch: {
    $route(to, from) {
      const fromAdminSettings = from.path.includes(this.SYSTEM_ADMIN_PATH);
      const toAdminSettings = to.path.includes(this.SYSTEM_ADMIN_PATH);

      if (!fromAdminSettings && toAdminSettings) {
        this.setState(MENU_STATE.AdminPage);
      }
      if (fromAdminSettings && !toAdminSettings) {
        this.setState(MENU_STATE.MainPage);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
    padding-left: 32px;
  }
</style>